import { GlobalConfig } from '@shared/types/GlobalConfig';

const globalConfig: GlobalConfig = {
  supportPromotions: true,
  cardShadow: true,
  digitalProduct: { maxQuantity: 100 },
  fitment: {
    autoToggleFitmentOnNavigateToParts: true,
    includeNonFitmentParts: true,
    includeUniversal: true,
  },
  supportFreeSale: false,
};

export default globalConfig;
